import { render, staticRenderFns } from "./Activesvip.vue?vue&type=template&id=13f6486b&scoped=true&"
import script from "./Activesvip.vue?vue&type=script&lang=js&"
export * from "./Activesvip.vue?vue&type=script&lang=js&"
import style0 from "./Activesvip.vue?vue&type=style&index=0&id=13f6486b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f6486b",
  null
  
)

export default component.exports